import "./FiguresItemBlock.scss";
import { Link } from "/App.Components";
import { createSpreadableBem } from "/Helpers/createBem";
import { FiguresItemBlockProps } from "/Models/Generated/FiguresItemBlockProps";
import { NoradTheme } from "/Models/Generated/NoradTheme";

interface FiguresItemBlockPropsExtended extends FiguresItemBlockProps {
  theme?: NoradTheme;
  lastItem?: boolean;
}

const FiguresItemBlock = ({
  figure,
  unitOfMeasurement,
  explanatoryText,
  readMore,
  theme = NoradTheme.Primary,
  lastItem = false,
}: FiguresItemBlockPropsExtended) => {
  const ariaLabel = figure + " " + unitOfMeasurement + " " + explanatoryText;
  const bem = createSpreadableBem("figures-item-block-norad");
  return (
    // biome-ignore lint/a11y/useSemanticElements: role="group" avoids the element being registered as its own landmark region (which <fieldset> would not resolve, as it is a form-grouping element, not applicable here).
    <div
      {...bem("", {
        "--last-item": lastItem,
        "--primary": theme === NoradTheme.Primary,
        "--secondary": theme === NoradTheme.Secondary,
        "--ternary": theme === NoradTheme.Ternary,
      })}
      role="group"
      aria-label={ariaLabel}
    >
      {figure && (
        <p
          aria-hidden="true"
          {...bem("__figure", {
            "--primary": theme === NoradTheme.Primary,
            "--secondary": theme === NoradTheme.Secondary,
            "--ternary": theme === NoradTheme.Ternary,
          })}
        >
          {figure}
        </p>
      )}
      {unitOfMeasurement && (
        <p
          aria-hidden="true"
          {...bem("__unit", {
            "--primary": theme === NoradTheme.Primary,
            "--secondary": theme === NoradTheme.Secondary,
            "--ternary": theme === NoradTheme.Ternary,
          })}
        >
          {unitOfMeasurement}
        </p>
      )}
      {explanatoryText && (
        <p
          aria-hidden="true"
          {...bem("__explanation", {
            "--primary": theme === NoradTheme.Primary,
            "--secondary": theme === NoradTheme.Secondary,
            "--ternary": theme === NoradTheme.Ternary,
          })}
        >
          {explanatoryText}
        </p>
      )}
      {readMore && <Link {...readMore} size="x-small" hasUnderline={true} />}
    </div>
  );
};

export default FiguresItemBlock;
